export default "__VITE_ASSET__CZj_VkmG__"